export const USER_NOTE_REQUEST = "USER_NOTE_REQUEST";
export const USER_NOTE_FAILURE = "USER_NOTE_FAILURE";

export const USERS_GET_STATS_SUCCESS = "USERS_GET_STATS_SUCCESS";

export const USERS_CREATE_NOTE_SUCCESS = "USERS_CREATE_NOTE_SUCCESS";
export const USERS_UPDATE_NOTE_SUCCESS = "USERS_UPDATE_NOTE_SUCCESS";
export const USERS_DELETE_NOTE_SUCCESS = "USERS_DELETE_NOTE_SUCCESS";
export const USERS_GET_NOTE_SUCCESS = "USERS_GET_NOTE_SUCCESS";

export const USERS_IN_PROGRESS_NOTE_SUCCESS = "USERS_IN_PROGRESS_NOTE_SUCCESS";
export const USERS_PUBLISHED_NOTE_SUCCESS = "USERS_PUBLISHED_NOTE_SUCCESS";

export const USER_DOWNLOAD_NOTE_SUCCESS = "USER_DOWNLOAD_NOTE_SUCCESS";

export const USER_BUYER_REQUEST_NOTE_SUCCESS = "USER_BUYER_REQUEST_NOTE_SUCCESS";
export const USER_ALLOW_DOWNLOAD_NOTE_SUCCESS = "USER_ALLOW_DOWNLOAD_NOTE_SUCCESS";

export const USER_MY_DOWNLOAD_NOTE_SUCCESS = "USER_MY_DOWNLOAD_NOTE_SUCCESS";
export const USER_MY_SOLD_NOTE_SUCCESS = "USER_MY_SOLD_NOTE_SUCCESS";
export const USER_MY_REJECTED_NOTE_SUCCESS = "USER_MY_REJECTED_NOTE_SUCCESS";

export const USER_ADD_REVIEW_SUCCESS = "USER_ADD_REVIEW_SUCCESS";

export const USER_ADD_NOTE_SPAM_SUCCESS = "USER_ADD_NOTE_SPAM_SUCCESS";

export const USER_CLONE_NOTE_SUCCESS = "USER_CLONE_NOTE_SUCCESS";

export const USER_GET_NOTE_REVIEW_SUCCESS = "USER_GET_NOTE_REVIEW_SUCCESS";
export const USER_DELETE_NOTE_REVIEW_SUCCESS = "USER_DELETE_NOTE_REVIEW_SUCCESS";

export const USER_GET_SEARCH_NOTES_SUCCESS = "USER_GET_SEARCH_NOTES_SUCCESS";
